import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { getContent } from '../../util/responseUtil';
import API_SOLUTION from '../../api/apiSolution';
import API_TICKET_LIST from '../../api/apiTicketList';
import FilterCustomerService from './FilterCustomerService';
import FilterPriority from './FilterPriority';
import FilterDateRange from './FilterDateRange';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import IconCheckmarkCircle from '../../assets/icons/IconCheckmarkCircle';
import IconUncheckCircle from '../../assets/icons/IconUncheckCircle';

class FilterTicket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showFilter: false,
            showCollapse1: true,
            showCollapse2: false,
            showCollapse3: false,
            showCollapse4: false,
            priority: {
                page: 1,
                limit: 10,
                data: [],
                value: ''
            },
            userCustomerService: {
                page: 1,
                limit: 100,
                data: [],
                value: '',
                id: ''
            },
            startDate: '',
            endDate: '',
            status: {
                data: [
                    {
                        label: 'Closed',
                        value: 'close'
                    },
                    {
                        label: 'Resolved',
                        value: 'resolved'
                    },
                    {
                        label: 'Under Observation',
                        value: 'underobservation'
                    }
                ],
                value: []
            },
            serverTime: '',
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleCollapse1 = () => {
        this.setState({
            showCollapse1: !this.state.showCollapse1,
            showCollapse2: false,
            showCollapse3: false,
            showCollapse4: false,
        })
    }

    handleCollapse2 = () => {
        this.setState({
            showCollapse1: false,
            showCollapse2: !this.state.showCollapse2,
            showCollapse3: false,
            showCollapse4: false,
        })
    }

    handleCollapse3 = () => {
        this.setState({
            showCollapse1: false,
            showCollapse2: false,
            showCollapse3: !this.state.showCollapse3,
            showCollapse4: false,
        })
    }

    handleCollapse4 = () => {
        this.setState({
            showCollapse1: false,
            showCollapse2: false,
            showCollapse3: false,
            showCollapse4: !this.state.showCollapse3,
        })
    }

    getListUserCustomerService = () => {
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)) {
            API_TICKET_LIST.getListUserCSTicketAll(this.state.userCustomerService.page, this.state.userCustomerService.limit, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            userCustomerService: {
                                ...this.state.userCustomerService,
                                data: getContent(res)
                            }
                        });
                    }
                })
        }
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION)) {
            API_SOLUTION.getListUserCSTicketSolution(this.state.userCustomerService.page, this.state.userCustomerService.limit, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            userCustomerService: {
                                ...this.state.userCustomerService,
                                data: getContent(res)
                            }
                        });
                    }
                })
        }
    }

    getSearchUserCustomerService = () => {
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)) {
            API_TICKET_LIST.getSearchUserCSTicketAll(this.state.userCustomerService.page, this.state.userCustomerService.limit, this.state.userCustomerService.value, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            userCustomerService: {
                                ...this.state.userCustomerService,
                                data: getContent(res)
                            }
                        });
                    }
                })
        }
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION)) {
            API_SOLUTION.getSearchUserCSTicketSolution(this.state.userCustomerService.page, this.state.userCustomerService.limit, this.state.userCustomerService.value, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            userCustomerService: {
                                ...this.state.userCustomerService,
                                data: getContent(res)
                            }
                        });
                    }
                })
        }
    }

    getListPriority = () => {
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)) {
            API_TICKET_LIST.getListPriorityTicketAll(this.state.priority.page, this.state.priority.limit, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        let allPriority = {
                            id: 0,
                            remark: 'semua',
                            description: 'Semua'
                        }
                        getContent(res).unshift(allPriority)
                        this.setState({
                            priority: {
                                ...this.state.priority,
                                data: getContent(res)
                            }
                        })
                    }
                })
        }
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION)) {
            API_SOLUTION.getListPriorityTicketSolution(this.state.priority.page, this.state.priority.limit, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        let allPriority = {
                            id: 0,
                            remark: 'semua',
                            description: 'Semua'
                        }
                        getContent(res).unshift(allPriority)
                        this.setState({
                            priority: {
                                ...this.state.priority,
                                data: getContent(res)
                            }
                        })
                    }
                })
        }
    }

    getDateRange = (from, to) => {
        this.setState({
            startDate: from,
            endDate: to
        })
    }

    handleSelectCustomerService = data => {
        this.setState({
            userCustomerService: {
                ...this.state.userCustomerService,
                value: data.name,
                id: data.user_nexcare_id
            }
        })
    }

    handleChangeCustomerService = async e => {
        await this.setState({
            userCustomerService: {
                ...this.state.userCustomerService,
                value: e.target.value
            }
        })
        if (this.state.userCustomerService.value === '') {
            this.getListUserCustomerService();
        } else {
            this.getSearchUserCustomerService();
        }
    }

    handleClear = async () => {
        this.setState({
            userCustomerService: {
                ...this.state.userCustomerService,
                value: '',
                id: ''
            }
        })
        this.getListUserCustomerService();
    }

    handleChangePriority = data => {
        this.setState({
            priority: {
                ...this.state.priority,
                value: data.value
            }
        })
    }

    handleChangeStatus = data => {
        if (this.state.status.value.includes(data.value)) {
            return this.setState({
                status: {
                    ...this.state.status,
                    value: this.state.status.value.filter(item => item !== data.value)
                }
            })
        }
        this.setState({
            status: {
                ...this.state.status,
                value: [...this.state.status.value, data.value]
            }
        })
    }

    handleDateRange = (from, to) => {
        this.setState({
            startDate: moment(from).format('YYYY-MM-DD'),
            endDate: moment(to).format('YYYY-MM-DD')
        })
    }

    handleFilter = () => {
        let filter

        filter = {
            customerService: this.state.userCustomerService.id,
            priority: this.state.priority.value === 0 ? 'all' : this.state.priority.value,
            startDate: this.state.startDate === '' ? '' : moment(this.state.startDate).format('YYYY-MM-DD'),
            endDate: this.state.endDate === '' ? '' : moment(this.state.endDate).format('YYYY-MM-DD'),
            status: this.state.status.value.length === 0 ? '' : this.state.status.value.toString()
        }

        this.props.handleFilter(filter)

        this.setState({
            showFilter: false,
            showCollapse1: true,
            showCollapse2: false,
            showCollapse3: false,
            showCollapse4: false,
        })
    }

    handleResetFilter = () => {
        this.setState({
            showFilter: false,
            showCollapse1: true,
            showCollapse2: false,
            showCollapse3: false,
            showCollapse4: false,
            userCustomerService: {
                ...this.state.userCustomerService,
                value: '',
                id: ''
            },
            priority: {
                ...this.state.priority,
                value: ''
            },
            status: {
                ...this.state.status,
                value: []
            },
            startDate: '',
            endDate: ''
        })
        this.props.resetFilter()
    }

    handleCollapseFilter = e => {
        if (this.filterButtonRef.current === null || this.filterRef.current === null) {
            return
        }
        if (this.filterButtonRef && !this.filterButtonRef.current.contains(e.target) && this.filterRef && !this.filterRef.current.contains(e.target)) {
            this.setState({
                showFilter: false
            })
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.filterButtonRef = createRef();
        this.filterRef = createRef();

        this.getListPriority();
        this.getListUserCustomerService();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showFilter !== this.state.showFilter) {
            if (this.state.showFilter) {
                document.addEventListener('click', this.handleCollapseFilter)
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        document.removeEventListener('click', this.handleCollapseFilter);
    }

    render() {
        return (
            <div className="inline-block relative">
                <div
                    className="rounded-full bg-white text-darkblue font-bold shadow-lg border-2 border-white px-8 py-2 mr-5 flex justify-between items-center cursor-pointer"
                    id="btnfilterticket"
                    onClick={() => this.setState({ showFilter: !this.state.showFilter })}
                    ref={this.filterButtonRef}
                >
                    <p className="mr-2">Filter</p>
                    <FontAwesomeIcon icon={faChevronDown} />
                </div>
                {
                    this.state.showFilter &&
                    <div className="absolute bg-white shadow-lg rounded-lg mt-4 w-80 text-gray-600 select-none z-50" ref={this.filterRef}>
                        <div className="border-b border-gray-300 py-2">
                            <div className="flex justify-between items-center px-5" id="btncollapse1" onClick={() => this.handleCollapse1()}>
                                <p className="font-medium">Nama CS</p>
                                <FontAwesomeIcon icon={this.state.showCollapse1 ? faChevronUp : faChevronDown} className="text-darkblue" />
                            </div>
                            {
                                this.state.showCollapse1 &&
                                <div className="bg-blue-50 px-5 mt-1">
                                    <FilterCustomerService
                                        data={this.state.userCustomerService}
                                        handleChangeCustomerService={this.handleChangeCustomerService}
                                        handleSelectCustomerService={this.handleSelectCustomerService}
                                        handleClear={this.handleClear}
                                    />
                                </div>
                            }
                        </div>
                        <div className="border-b border-gray-300 py-2">
                            <div className="flex justify-between items-center px-5" id="btncollapse2" onClick={() => this.handleCollapse2()}>
                                <p className="font-medium">Prioritas</p>
                                <FontAwesomeIcon icon={this.state.showCollapse2 ? faChevronUp : faChevronDown} className="text-darkblue" />
                            </div>
                            {
                                this.state.showCollapse2 &&
                                <div className="bg-blue-50 mt-1">
                                    <FilterPriority
                                        handleChange={this.handleChangePriority}
                                        data={this.state.priority.data.map(data => ({ value: data.id, label: data.description, remark: data.remark }))}
                                    />
                                </div>
                            }
                        </div>
                        <div className="border-b border-gray-300 py-2">
                            <div className="flex justify-between items-center px-5" id="btncollapse3" onClick={() => this.handleCollapse3()}>
                                <p className="font-medium">Tanggal</p>
                                <FontAwesomeIcon icon={this.state.showCollapse3 ? faChevronUp : faChevronDown} className="text-darkblue" />
                            </div>
                            {
                                this.state.showCollapse3 &&
                                <div className="px-5 mt-1">
                                    <FilterDateRange
                                        getDateRange={this.getDateRange}
                                    />
                                </div>
                            }
                        </div>
                        {
                            window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION) &&
                            <div className="border-b border-gray-300 py-2">
                                <div className="flex justify-between items-center px-5" id="btncollapse4" onClick={() => this.handleCollapse4()}>
                                    <p className="font-medium">Status</p>
                                    <FontAwesomeIcon icon={this.state.showCollapse4 ? faChevronUp : faChevronDown} className="text-darkblue" />
                                </div>
                                {
                                    this.state.showCollapse4 &&
                                    <div className="bg-blue-50 mt-1">
                                        <div className="text-sm">
                                            {
                                                this.state.status.data.map((data, idx) =>
                                                    <div className="dropdown-list__item" key={idx} id="btnselectstatus" onClick={() => this.handleChangeStatus(data)}>
                                                        {
                                                            this.state.status.value.includes(data.value) ?
                                                                <div className="pt-3 pl-5 pr-5 bg-blue-200">
                                                                    <div className="pb-3 flex items-center border-b-2 border-gray capitalize">
                                                                        <IconCheckmarkCircle />
                                                                        <div className="ml-2">{data.label}</div>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="pt-3 pl-5 pr-5 hover:bg-blue-100">
                                                                    <div className="pb-3 flex items-center border-b-2 border-gray capitalize">
                                                                        <IconUncheckCircle />
                                                                        <div className="ml-2">{data.label}</div>
                                                                    </div>
                                                                </div>
                                                        }
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        <div className="flex justify-between items-center my-3 mx-5">
                            <button
                                type="button"
                                id="btnreset"
                                className="bg-darkred rounded text-white focus:outline-none py-0.5 px-5"
                                onClick={() => this.handleResetFilter()}
                            >
                                Reset
                            </button>
                            <button
                                type="button"
                                id="btnfilter"
                                className="bg-lightblue rounded text-white focus:outline-none py-0.5 px-5"
                                onClick={() => this.handleFilter()}
                            >
                                Terapkan
                            </button>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

export default connect(mapStateToProps, null)(FilterTicket);